export let EmailOnBehalfTypes = /*#__PURE__*/function (EmailOnBehalfTypes) {
  EmailOnBehalfTypes["Sendgrid"] = "sendgrid";
  EmailOnBehalfTypes["Gmail"] = "gmail";
  EmailOnBehalfTypes["Outlook"] = "outlook";
  return EmailOnBehalfTypes;
}({});
export class EmailOnBehalfSettingsModel {
  static fromDTO(dto) {
    if (dto.provider === EmailOnBehalfTypes.Sendgrid) {
      return new EmailOnBehalfSettingsModel({
        provider: EmailOnBehalfTypes.Sendgrid,
        email: 'system@notifications.sayanchor.com'
      });
    } else if (dto.provider === EmailOnBehalfTypes.Gmail) {
      return new EmailOnBehalfSettingsModel({
        provider: EmailOnBehalfTypes.Gmail,
        email: dto.email
      });
    } else {
      return new EmailOnBehalfSettingsModel({
        provider: EmailOnBehalfTypes.Outlook,
        email: dto.email
      });
    }
  }
  static makeDisconnected() {
    return EmailOnBehalfSettingsModel.fromDTO({
      provider: EmailOnBehalfTypes.Sendgrid,
      email: null
    });
  }
  constructor(data) {
    this.data = data;
  }
  email() {
    return this.data.email;
  }
  provider() {
    if (this.data.provider !== EmailOnBehalfTypes.Sendgrid) {
      return this.data.provider;
    }
    return null;
  }
  isDisconnected() {
    return this.data.provider === EmailOnBehalfTypes.Sendgrid;
  }
}